import { Skeleton } from "@/shared/ui/kit/skeleton";

export function SearchResultItemSkeleton() {
  return (
    <div className="w-full rounded-lg px-3 py-3">
      <div className="flex w-full items-center gap-3">
        {/* Image skeleton */}
        <Skeleton className="h-10 w-10 shrink-0 rounded-md" />

        {/* Content skeleton */}
        <div className="flex-1 min-w-0 space-y-2">
          <div className="flex items-center gap-2">
            <Skeleton className="h-5 w-8 rounded" />
            <Skeleton className="h-5 flex-1 max-w-[60%]" />
            <Skeleton className="h-4 w-16" />
          </div>
          <Skeleton className="h-5 w-24 rounded" />
        </div>

        {/* Chevron skeleton */}
        <Skeleton className="h-4 w-4 shrink-0 rounded" />
      </div>
    </div>
  );
}

export function SearchResultListSkeleton({ count = 5 }: { count?: number }) {
  return (
    <div className="p-2 space-y-1">
      {Array.from({ length: count }).map((_, i) => (
        <SearchResultItemSkeleton key={i} />
      ))}
    </div>
  );
}
